import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styles from './css/Profile.scss';

@injectIntl
export default class ProfileInfo extends Component {
    static propTypes = {
        intl: intlShape,
        user: ImmutablePropTypes.map.isRequired,
    }

    render() {
        const {user} = this.props;
        if (!user) return null;

        return (
            <div className={styles.wrapper}>
                <div className={styles.sections}>
                    <div>
                        <ul className={styles.details}>
                            <li>
                                <strong><FormattedMessage id='frontend.settings.profile.name'/>: </strong>
                                {user.get('name')}
                            </li>
                            <li>
                                <strong><FormattedMessage id='frontend.settings.profile.email'/>: </strong>
                                {user.get('email')}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}
